/**
 * @author xyguo
 * @description 证书管理页面
 * @Date 2020/9/10
 */
import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool,component_tool } from '../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport,WizCard,WizTabs,WizSpin} = component_tool;
class CertApplyList extends WizContainer {

  componentName = 'CertList';

  constructor(props) {
    super(props);
    this.state = {
      selectedClassResultRows: [],//选择的学员
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _templateConfig = templateConfig({
      onSelect: (keys, rows) => {
        this.setState({
          selectedClassResultRows: rows,
          selectedRows: rows.length,
          data: new Date().getTime(),
          rows: rows
        });
      },
      _this: this,
     // classInfoId,
      // _btnLookUserFun: (e) => {
      //   if (e.record) {
      //     let classResultRecord = e.record;
      //     this._showUserPersonModal(classResultRecord);
      //   }
      // }
    });

    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        enable: this._handleCMD,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(CertApplyList);
